import type { ColumnDef } from '@/components/ui';
import { DataTable, ErrorBanner, PageHeader, PageLoading } from '@/components/ui';
import type { IIncident } from '@skystone/shared';
import { incidentApi } from '@/services/incident-api';
import { useApi } from '@/hooks/useApi';
import { buildRawColumns, buildStandardEmptyMessage, buildStandardTblSubtitle } from '@/lib/tbl-page-utils';
import { PageContainer } from '@/components/layout';

const incidentColumns: ColumnDef<IIncident>[] = buildRawColumns<IIncident>([
  { key: 'id', header: 'ID' },
  { key: 'title', header: 'Title' },
  { key: 'incidentDate', header: 'Incident Date' },
  { key: 'productId', header: 'Product ID' },
  { key: 'productName', header: 'Product Name' },
  { key: 'fabricProductId', header: 'Fabric Product ID' },
  { key: 'severity', header: 'Severity' },
  { key: 'archived', header: 'Archived' },
  { key: 'archivedAt', header: 'Archived At' },
  { key: 'fabricSynced', header: 'Fabric Synced' },
  { key: 'fabricSyncedAt', header: 'Fabric Synced At' },
  { key: 'createdAt', header: 'Created At' },
  { key: 'updatedAt', header: 'Updated At' },
]);

export function IncidentsPage() {
  const { data: incidents, loading, error } = useApi(() => incidentApi.getAll(), []);

  if (loading && !incidents) {
    return <PageLoading />;
  }

  return (
    <PageContainer variant="wide" className="space-y-6">
      <PageHeader
        title="Tbl - incidents"
        subtitle={buildStandardTblSubtitle()}
      />

      <ErrorBanner message={error} />

      <DataTable
        data={incidents ?? []}
        columns={incidentColumns}
        keyExtractor={(incident) => incident.id}
        enablePagination
        enableFilters
        emptyMessage={buildStandardEmptyMessage('incident')}
      />
    </PageContainer>
  );
}
